import { LayerRenderer } from '../LayerRenderer';
import {
  CloseButton,
  animationClass,
  cardStyle,
  useDismissible,
  type SurfaceProps,
} from './common';

/**
 * Zásuvka v rohu (slide-in). NEmodální — nepřerušuje, nemá overlay ani
 * scroll-lock. Na mobilu sedí dole a nepřekrývá košíkové CTA (řeší CSS).
 */
export function SlideInSurface({ layer, onClose, onInteract, onSubmitted }: SurfaceProps) {
  const settings = layer.doc.settings;
  useDismissible(onClose);
  const corner =
    settings.position === 'bottom_left'
      ? 'is-bottom-left'
      : settings.position === 'top_right'
        ? 'is-top-right'
        : settings.position === 'top_left'
          ? 'is-top-left'
          : 'is-bottom-right';

  return (
    <div
      className={`layer-slidein ${corner} ${animationClass(settings)}`}
      style={cardStyle(settings, true)}
      role="dialog"
      aria-label={settings.dismissLabel ?? 'Sdělení'}
    >
      {(settings.closeButton ?? true) && <CloseButton onClose={onClose} />}
      <LayerRenderer
        layer={layer}
        onClose={onClose}
        onInteract={onInteract}
        onSubmitted={onSubmitted}
      />
    </div>
  );
}
